var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white md:bg-gray-lighter"},[_c('Modules')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }